import React from "react";
import "./Solution.css";

export default function Solution() {
  const sections = [
    {
      title: "1. Retail Insights",
      subTitle: "Unlock the Power of Data-Driven Retail",
      description:
        "Retail is no longer just about what sells — it’s about where, when, and why. At Orbi Nexum, we empower retailers to blend transactional, behavioral, and geospatial data to drive smarter decisions, faster.",
      points: [
        "In-Store Heatmaps: Visualize foot traffic with geospatial overlays to optimize product placement and store layout.",
        "Location Planning: Combine POS and loyalty data with neighborhood demographics to identify high-opportunity expansion zones.",
        "Sales Anomaly Detection: Use external data like weather, local events, or economic shifts to flag unexpected regional sales trends.",
      ],
    },
    {
      title: "2. Manufacturing Intelligence",
      subTitle: "Smarter Production with Predictive Analytics",
      description:
        "Today’s manufacturers need more than automation — they need foresight. We connect operational data with external geospatial layers and sensor inputs to help manufacturers predict, prevent, and perform better.",
      points: [
        "Supply Chain Visibility: Monitor shipments and routes in real-time using IoT data enriched with weather and geopolitical risk analytics.",
        "Predictive Quality Control: Train AI models on historical QA logs and machine sensor streams to preempt defects before they occur.",
        "Factory Intelligence Dashboards: Link energy consumption, production output, and location-based risk data to streamline efficiency.",
      ],
    },
    {
      title: "3. Telecom & Network Insights",
      subTitle: "Optimizing Connectivity with Spatial Awareness",
      description:
        "In telecom, geography defines opportunity. Our solutions enable CSPs to combine network performance data with urban growth patterns and subscriber behavior to uncover coverage gaps, reduce churn, and optimize rollout.",
      points: [
        "Service Gap Mapping: Identify underserved areas by mapping signal loss and churn hotspots against population density.",
        "Intelligent Infrastructure Planning: Use satellite imagery and city development trends to guide tower placement and fiber deployment.",
        "Location-Based Marketing: Merge usage analytics with geodemographic segmentation to personalize broadband and mobile campaigns.",
      ],
    },
    {
      title: "4. Agriculture Intelligence",
      subTitle: "Cultivating Efficiency with Location-Driven Analytics",
      description:
        "Modern agriculture thrives on precision. At Orbi Nexum, we empower agribusinesses to integrate satellite imagery, IoT sensor data, and geospatial insights to enhance yield, reduce waste, and respond to environmental change.",
      points: [
        "Precision Crop Monitoring: Combine multispectral satellite imagery with in-field sensors to detect crop stress, optimize irrigation, and monitor plant health in real time.",
        "Yield Forecasting: Fuse historical yield data with soil conditions, weather patterns, and market demand to predict harvest volumes and guide pricing strategies.",
        "Land Suitability Analysis: Use geospatial modeling and climate data to evaluate and rank land parcels for optimal crop selection and sustainable expansion.",
      ],
    },
  ];

  return (
    <section className="solution-section" id="Solution">
      <h1 className="solution-title">Solutions</h1>
      <div className="solution-grid">
        {sections.map((section, index) => (
          <div key={index} className="solution-block">
            <h2 className="solution-heading">{section.title}</h2>
            <h3 className="solution-subtitle">{section.subTitle}</h3>
            <p className="solution-description">{section.description}</p>
            <h4 className="solution-usecase-title">Use Case Examples:</h4>
            <ul className="solution-list">
              {section.points.map((point, i) => (
                <li key={i} className="solution-list-item">
                  {point}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
